exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".add-unit-modal-btn-vehicles{height:28px;border-top-left-radius:0;border-bottom-left-radius:0}.add-unit-modal-vehicles-text{padding-right:1.3rem}.add-unit-modal-vehicles{margin-top:.5rem}\n", ""]);

// exports
